import { createSlice } from '@reduxjs/toolkit';
import { admin_apiEndpoint, config_variable } from '../../helper/commonApi';
import { getPriceUpdateLogAsync, deletePriceUpdateLogAsync } from './index';

const initialState = {
    priceUpdateLogData: [],
    isLoading: false,
    isError: false,
    pagination: {
        totalCount: 0,
        totalPages: 0,
        currentPage: 1,
        perPage: 10
    },
    updateMethod: 'Auto',
    autoInterval: null,
    isDeleteLoading: false
}

const priceUpdateLogSlice = createSlice({
    name: 'priceUpdateLog',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getPriceUpdateLogAsync.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(getPriceUpdateLogAsync.fulfilled, (state, { payload }) => {
                state.isLoading = false;
                if (payload) {
                    state.priceUpdateLogData = payload.data;
                    state.pagination = payload.pagination;
                    state.updateMethod = payload.updateMethod;
                    state.autoInterval = payload.autoInterval;
                }
            })
            .addCase(getPriceUpdateLogAsync.rejected, (state) => {
                state.isLoading = false;
                state.isError = false;
                state.priceUpdateLogData = [];
                state.updateMethod = 'Auto';
                state.autoInterval = null;
                state.pagination = {
                    totalCount: 0,
                    totalPages: 0,
                    currentPage: 1,
                    perPage: 10
                };
                // if (window.location.hostname !== 'localhost') {
                //     window.parent.location.href = `${admin_apiEndpoint}?shop=${config_variable.shop_name}&host=${config_variable?.config.host}`;
                // }
            })
            .addCase(deletePriceUpdateLogAsync.pending, (state) => {
                state.isDeleteLoading = true;
            })
            .addCase(deletePriceUpdateLogAsync.rejected, (state) => {
                state.isDeleteLoading = false;
                state.isError = false;
            })
            .addCase(deletePriceUpdateLogAsync.fulfilled, (state, { payload }) => {
                state.isDeleteLoading = false;
                state.isError = false;
            })
    },
});

export const getAllPriceUpdateLog = (state) => state.priceUpdateLog;

export default priceUpdateLogSlice.reducer;
